import React from "react";
import { graphql, compose } from "react-apollo";
import gql from "graphql-tag";
import deleteImg from "../../img/delete.svg";
import Select from "react-select";
import DatePicker from "react-datepicker-timechange";
import "react-datepicker-timechange/dist/react-datepicker.css";
import moment from "moment-timezone";
import SpecialDayInput from "./SpecialDayInput";
class SpecialDaySelect extends React.Component {
  constructor(props) {
    super(props);
    let endDate =
      this.props.specialDay.endDate === null
        ? null
        : moment(this.props.specialDay.endDate);
    this.state = {
      value: this.props.specialDay.dayTemplate
        ? this.props.specialDay.dayTemplate.id
        : null,
      startDate: moment(this.props.specialDay.date),
      endDate: endDate,
      isSingleDate: this.props.specialDay.endDate === null ? true : false
    };
  }

  handleSelectChange = async dayTemplate => {
    this.setState({
      value: dayTemplate.id
    });
    this.handleUpdate(
      this.props.specialDay.id,
      this.state.startDate,
      this.state.endDate,
      dayTemplate.id
    );
  };

  handleDateChange = date => {
    if (date === null) {
      this.setState({
        startDate: null,
        endDate: null
      });
    } else if (this.state.startDate === null && this.state.endDate === null) {
      this.setState(
        {
          startDate: date,
          endDate: null
        },
        () =>
          this.handleUpdate(
            this.props.specialDay.id,
            this.state.startDate,
            this.state.endDate,
            this.props.specialDay.dayTemplate.id
          )
      );
    } else if (
      this.state.startDate !== null &&
      this.state.endDate === null &&
      !this.state.isSingleDate
    ) {
      this.setState(
        {
          //  startDate: date,
          endDate: date
        },
        () =>
          this.handleUpdate(
            this.props.specialDay.id,
            this.state.startDate,
            this.state.endDate,
            this.props.specialDay.dayTemplate.id
          )
      );
    } else if (this.state.startDate !== null && this.state.endDate !== null) {
      if (date.isBefore(this.state.startDate)) {
        this.setState(
          {
            startDate: date,
            endDate: this.state.startDate
          },
          () =>
            this.handleUpdate(
              this.props.specialDay.id,
              this.state.startDate,
              this.state.endDate,
              this.props.specialDay.dayTemplate.id
            )
        );
      } else if (date.isBefore(this.state.endDate)) {
        this.setState(
          {
            //  startDate: date,
            endDate: date
          },
          () =>
            this.handleUpdate(
              this.props.specialDay.id,
              this.state.startDate,
              this.state.endDate,
              this.props.specialDay.dayTemplate.id
            )
        );
      } else {
        this.setState(
          {
            startDate: date,
            endDate: null
          },
          () =>
            this.handleUpdate(
              this.props.specialDay.id,
              this.state.startDate,
              this.state.endDate,
              this.props.specialDay.dayTemplate.id
            )
        );
      }
    } else {
      this.setState(
        {
          startDate: date,
          endDate: null
        },
        () =>
          this.handleUpdate(
            this.props.specialDay.id,
            this.state.startDate,
            this.state.endDate,
            this.props.specialDay.dayTemplate.id
          )
      );
    }
  };

  handleDelete = () => {
    this.props.toggleConfirm();

    this.props.setHandleCancel(this.handleRealDelete);
  };

  handleRealDelete = async () => {
    const id = this.props.specialDay.id;

    await this.props
      .deleteSpecialDayMutation({
        variables: { id }
      })
      .then(() => {
        this.props.toggleConfirm();
        this.props.refetch();
      })
      .catch(e => {
        console.error("delete specialday", e);
      });
  };

  handleUpdate = async (id, date, endDate, dayTemplateId) => {
    date = date.toDate();
    if (endDate != null) {
      endDate = endDate.toDate();
    }
    await this.props
      .updateSpecialDayMutation({
        variables: { id, date, endDate, dayTemplateId }
      })
      .then(() => {
        this.props.refetch();
      })
      .catch(e => {
        console.error("update specialday", e);
      });
  };

  render() {
    let isSingle = this.state.isSingleDate;
    return (
      <div key={this.props.specialDay.id} className="week-day-select">
        <span>
          <DatePicker
            isClearable={true}
            customInput={
              <SpecialDayInput
                startDate={this.state.startDate}
                endDate={this.state.endDate}
              />
            }
            selected={this.state.startDate}
            selectsEnd={!isSingle}
            startDate={this.state.startDate}
            endDate={this.state.endDate}
            onChange={this.handleDateChange}
            shouldCloseOnSelect={isSingle}
          />
        </span>
        <Select
          value={this.state.value}
          onChange={v => this.handleSelectChange(v)}
          options={this.props.options}
          valueKey="id"
          clearable={false}
          labelKey="name"
          placeholder="Sélectionnez un template"
          wrapperStyle={{
            width: "80%"
          }}
        />
        <span>
          <figure onClick={this.handleDelete} className="image is-32x32">
            <img alt="deleteImg" src={deleteImg} />
          </figure>
        </span>
      </div>
    );
  }
}

const UPDATE_SPECIALDAY_MUTATION = gql`
  mutation UpdateSpecialDayMutation(
    $id: ID!
    $date: DateTime!
    $endDate: DateTime
    $dayTemplateId: ID!
  ) {
    updateSpecialDay(
      id: $id
      date: $date
      endDate: $endDate
      dayTemplateId: $dayTemplateId
    ) {
      id
    }
  }
`;

const DELETE_SPECIALDAY_MUTATION = gql`
  mutation DeleteSpecialDayMutation($id: ID!) {
    deleteSpecialDay(id: $id) {
      id
    }
  }
`;

/*export default graphql(GET_DAYTEMPLATE_QUERY, {
  name: "getDayTemplate",
  options: ({ templateId }) => ({ variables: { templateId } })
})(EditTemplate);*/
export default compose(
  graphql(UPDATE_SPECIALDAY_MUTATION, {
    name: "updateSpecialDayMutation"
  }),
  graphql(DELETE_SPECIALDAY_MUTATION, {
    name: "deleteSpecialDayMutation"
  })
)(SpecialDaySelect);



// WEBPACK FOOTER //
// ./src/components/utilities/SpecialDaySelect.js